import { OrdPdtModel } from "@app/models/shoppingmall/order-pdt.model";
import { createAction, props } from "@ngrx/store";

//load
export const loadPdtWishList = createAction(
    "[Product API] load product whislist",
    props<{params: any}>()
);

export const loadPdtWishListSuccess = createAction(
    "[Product API] load product whislist success",
    props<{items: OrdPdtModel[]}>()
);

export const loadPdtWishListFailure = createAction(
    "[Product API] load product whislist failure",
    props<{msg: any}>()
)

//count
export const countPdtWishList = createAction(
    "[Product API] count product whislist",
    props<{params: any}>()
);

export const countPdtWishListSuccess = createAction(
    "[Product API] count product whislist success",
    props<{total: number}>()
);

export const countPdtWishListFailure = createAction(
    "[Product API] count product whislist failure",
    props<{msg: any}>()
);

//save
export const savePdtWishList = createAction(
    "[Product API] save product whislist",
    props<{userid: string, pdtCd: string}>()
);

export const savePdtWishListSuccess = createAction(
    "[Product API] save product whislist success",
    props<{msg: any}>()
);

export const savePdtWishListFailure = createAction(
    "[Product API] save product whislist failure",
    props<{msg: any}>()
)

//del
export const delPdtWishList = createAction(
    "[Product API] del product whislist",
    props<{userid: string, pdtCd: string}>()
);

export const delPdtWishListSuccess = createAction(
    "[Product API] del product whislist success",
    props<{msg: any}>()
);

export const delPdtWishListFailure = createAction(
    "[Product API] del product whislist failure",
    props<{msg: any}>()
)

export const actionSetWishYN = createAction(
    "[Product API] set wish yn with pdt cd",
    props<{pdtCd: string , wishYn: string}>()

)

// delete product wish list
export const actionDeleteProductWishList = createAction(
  "[Product API] delete product wish list",
  props<{ params : any }>()
);

export const actionDeleteProductWishListSuccess = createAction(
  "[Product API] delete product wish list success",
  props<{ msgDeleteWishList: any }>()
);

export const actionDeleteProductWishListFailure = createAction(
  "[Product API] delete product wish list failure",
  props<{ msgDeleteWishList: any }>()
);

// delete all product wish list
export const actionDeleteAllProductWishList = createAction(
  "[Product API] delete all product wish list",
  props<{ params : any }>()
);

export const actionDeleteAllProductWishListSuccess = createAction(
  "[Product API] delete all product wish list success",
  props<{ msgDeleteWishList: any }>()
);

export const actionDeleteAllProductWishListFailure = createAction(
  "[Product API] delete all product wish list failure",
  props<{ msgDeleteWishList: any }>()
);

export const actionClearMsg = createAction(
  "Clear msg",
  props<{ msgDeleteWishList: any }>()
);
